import {
  jb_fullscreen_icon_css_default
} from "./chunk.JK2RE4FX.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-fullscreen-icon/jb-fullscreen-icon.ts
var JbFullscreenIcon = class extends Icon(r) {
  render() {
    return ke`<div class="fullscreen-icon"></div>`;
  }
};
JbFullscreenIcon.styles = [reset_css_default, jb_fullscreen_icon_css_default];
JbFullscreenIcon = __decorateClass([
  customElement("jb-fullscreen-icon")
], JbFullscreenIcon);

export {
  JbFullscreenIcon
};
